export default () => ({
    init() {
        window.addEventListener('pushPromotionBannerGtmEvent', event => {
            pushToGtmDataLayer(event.detail.eventName, {
                ecommerce: {
                    creative_name: event.detail.promotionName,
                    creative_slot: 'classified search results',
                    items: [
                        {
                            item_name: event.detail.promotionName,
                            item_id: event.detail.promotionId,
                        },
                    ],
                },
            });
        });
    },
    pushToGtmDataLayer(eventName, data) {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: eventName,
                ...data,
            });
        }
    },
});
